export function getPaginationTotalLabel(size: number, totalElements: number, pageNumber: number): string {
  const lastPage = getLastPage(size, totalElements);

  let currentPage: number = pageNumber > lastPage ? lastPage : pageNumber;
  if (currentPage < 1) {
    currentPage = 1;
  }
  const rangeTop = size * currentPage;
  const rangeBottom = rangeTop - size + 1;
  const range = `${rangeBottom} - ${rangeTop > totalElements
    ? totalElements : rangeTop}`;

  return `Predpisy ${range} z ${totalElements}`;
}

export function getLastPage(size: number, totalElements: number): number {
  return totalElements > 0
    ? Math.ceil(totalElements / size) : 1;
}
